// src/pages/design/Fcr_view.jsx
import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import FormViewManager from "../../components/common/form/FormViewManager";
import TableCell from "../../components/common/ui/TableCell";
import PeopleView from "../../components/common/people/PeopleView";
import { getDocPersons } from "../../api/papers";
import { changeDocState } from "../../api/design/meta";
import ApprovalActionDoc from "../../components/approval/ApprovalAction_doc";
import SignTableDoc from "../../components/approval/SignTable_doc";
import ReviewOpinionDoc from "../../components/design/ReviewOpinionDoc";
import { updateMeta } from "../../api/design/meta";
import { viewApprovalLine } from "../../api/approval";



export default function Fcr_view({ print = false, onPrintReady }) {
  const { id: project, dns } = useParams();
  const navigate = useNavigate();

  const handleCreateFCN = () => {
    navigate(`/project/${project}/design/fcn/new?fromFCR=${dns}`);
  };

  const [docType, setDocType] = useState("fcr");

  useEffect(() => {
    if (window.location.pathname.toLowerCase().includes("/fcn/")) {
      setDocType("fcn");
    }
  }, []);

  const docNames = {
    fcr: { kor: "설계변경요청서", eng: "Field Change Request" },
    fcn: { kor: "설계변경통보서", eng: "Field Change Notice" },
  };

  const docName = docNames[docType]?.kor ?? "설계변경문서";
  const docEng = docNames[docType]?.eng ?? "Field Change Document";

  return (
    <FormViewManager
      params={{
        module: "design",
        doc_type: docType,
        project,
        dns,
      }}
      doc_name={docName}
      doc_eng={docEng}
      print={print}
      onPrintReady={onPrintReady}
    >
      <FcrViewContent
        onCreateFCN={handleCreateFCN}
        dns={dns}
        docType={docType}
      />
    </FormViewManager>
  );
}

function FcrViewContent({ meta, data, onCreateFCN, dns, docType }) {
  const { id: project } = useParams();
  const editorRef = useRef(null);

  const me = JSON.parse(localStorage.getItem("user") || "null");
  const myUserId = me?.id || me?.user?.id;

  const [people, setPeople] = useState([]);
  const [isEditingReview, setIsEditingReview] = useState(false);
  const [approvalLines, setApprovalLines] = useState([]);



  /** ------------------------------
   *  ReviewOpinion FORM STATE
   ------------------------------ */
  const [form, setForm] = useState({
    title: "",
    reportDate: "",
    period: "",
    purpose: "",
    content: "",
    result: "",
  });

  /** data → form 초기화 */
  useEffect(() => {
    if (!data) return;

    setForm({
      title: meta.title || "",
      reportDate: meta.reportDate || "",
      period: meta.period || "",
      purpose: meta.purpose || "",
      content: meta.content || "",
      result: meta.result || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  /** ------------------------------
   *  담당자 / 상태
   ------------------------------ */
  const docState =
    data?.state ?? meta?.state ?? data?.status ?? meta?.status ?? null;

  useEffect(() => {
    const loadPeople = async () => {
      try {
        const list = await getDocPersons(dns);
        setPeople(list || []);
      } catch {
        setPeople([]);
      }
    };
    loadPeople();
  }, [dns]);

  const isAssignee = people.some(
    (p) => p.id === myUserId || p.userId === myUserId || p.user_id === myUserId
  );

  const canReject = isAssignee && docState === "save";
  const canCreateFCN = isAssignee && docState === "save" && docType === "fcr";

  /** ------------------------------
   *  반려 처리
   ------------------------------ */
  const handleReject = async () => {
    if (!window.confirm("요청을 반려하시겠습니까?")) return;
    try {
      await changeDocState(dns, "reject");
      alert("요청이 반려되었습니다.");
      window.location.reload();
    } catch {
      alert("반려 처리 중 오류가 발생했습니다.");
    }
  };

  /** ------------------------------
   *  저장 (같이 저장)
   ------------------------------ */
  const handleSave = async () => {
    try {
      if (!data?.doc_dns) {
        alert("문서 번호(dns)를 찾을 수 없습니다.");
        return;
      }
      const content = editorRef.current?.getContent() || "";
      const payload = {
        meta: {
          // ⭐ 기존 meta 유지
          ...(meta || {}),

          // ⭐ ReviewOpinionDoc 내용도 meta 안으로
          title: form.title,
          reportDate: form.reportDate,
          period: form.period,
          purpose: form.purpose,
          content: content,
          result: form.result,
        },
      };
      console.log("📦 updateMeta dns >>>", data.doc_dns);
      console.log("📦 updateMeta payload >>>", payload);

      await updateMeta(data.doc_dns, payload);

      alert("저장되었습니다.");
      window.location.reload();
    } catch (e) {
      console.error(e);
      alert("저장 중 오류가 발생했습니다.");
    }
  };
  console.log(data)

  useEffect(() => {
    if (!dns) return;

    const loadApprovalLines = async () => {
      try {
        const res = await viewApprovalLine(dns);

        // 응답 구조 방어적으로 처리
        const lines =
          res?.data?.approval_lines

        console.log(res);

        setApprovalLines(Array.isArray(lines) ? lines : []);
      } catch (e) {
        console.error("결재선 조회 실패", e);
        setApprovalLines([]);
      }
    };

    loadApprovalLines();
  }, [dns]);


  const reviewerLine = approvalLines.find(
    (l) => Number(l.order) === 1
  );

  const reviewerId =
    reviewerLine?.approver_id ||
    reviewerLine?.user_id ||
    reviewerLine?.id;
  const isReviewer = Number(myUserId) === Number(reviewerId);



  return (
    <div className="text-[13px]">
      {/* 상단 버튼 */}
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-body-bold">
          {docType === "fcr" ? "요청 정보" : "통보 정보"}
        </h2>

        <div className="flex gap-2 no-print">
          {canCreateFCN && (
            <button
              onClick={onCreateFCN}
              className="px-3 py-1 border rounded text-sm"
            >
              FCN 생성
            </button>
          )}

          {canReject && (
            <button
              onClick={handleReject}
              className="px-3 py-1 border rounded text-sm text-red-600"
            >
              반려
            </button>
          )}

        </div>
      </div>
      {/* 기본 정보 */}
      <table className="w-full table-fixed mb-6">
        <colgroup>
          <col style={{ width: "120px" }} />
          <col />
          {/* <col style={{ width: "120px" }} /> */}
          <col />
        </colgroup>
        <tbody>
          <tr>
            <td className="tbl-label-bg w-32">공종</td>
            <td className="tbl-value-bg" colSpan={11}>
              {meta?.division || "-"}
            </td>
          </tr>

          {/* <tr>
            <td className="tbl-label-bg">종류</td>
            <td className="tbl-value-bg" colSpan={11}>
              자재
            </td>
          </tr> */}

          <tr>
            <td className="tbl-label-bg">위치</td>
            <td className="tbl-value-bg" colSpan={11}>
              <div className="flex items-center">
                <div className="flex-1 px-3 border-r border-gray-400">
                  지역 : <b>{meta?.area || ""}</b>
                </div>
                <div className="flex-1 px-3 border-r border-gray-400">
                  층 : <b>{meta?.level || ""}</b>
                </div>
                <div className="flex-1 px-3">
                  좌표 : <b>{meta?.grid || ""}</b>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td className="tbl-label-bg">승인요청일</td>
            <td className="tbl-value-bg" colSpan={5}>
              {meta?.request_date || "20  .  ."}
            </td>
            <td className="tbl-label-bg" colSpan={2}>시행일자</td>
            <td className="tbl-value-bg" colSpan={4}>
              {meta?.action_date || "20  .  ."}
            </td>
          </tr>
          <tr>
            <TableCell
              label={docType === "fcr" ? "변경 사유" : "변경 내용"}
              rich
              value={meta?.reason}
              colSpan={11}
            />
          </tr>
        </tbody>
      </table>

      {/* 변경 항목 */}
      <div className="print-table print-avoid-break">
        <h2 className="text-body-bold mb-2 print-table">변경 항목 내역</h2>

        <div className=" overflow-hidden mb-6">
          <table className="w-full text-[13px] leading-relaxed border border-black border-collapse">

            <thead className="doc-thead">
              <tr>
                <th className="doc-th w-10 text-center">No</th>
                <th className="doc-th w-1/4 text-center">도면번호</th>
                <th className="doc-th text-center">변경 전 내용</th>
                <th className="doc-th text-center">변경 후 내용</th>
                <th className="doc-th-end w-20 text-center">비고</th>
              </tr>
            </thead>

            <tbody>
              {Array.isArray(meta?.details) && meta.details.length > 0 ? (
                meta.details.map((r, i) => {
                  const drawingLink = r.drawingFileId
                    ? `/project/${project}/design/detail?doc=${r.drawingFileId}`
                    : null;

                  return (
                    <tr key={i} className="border-t border-black text-xs">
                      {/* No */}
                      <td className="border-r border-black text-center">
                        {i + 1}
                      </td>

                      {/* 도면번호 (= 항목) */}
                      <td className="border-r border-black text-center">
                        {drawingLink ? (
                          <a
                            href={drawingLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-indigo-600 underline hover:text-indigo-800"
                          >
                            {r.drawingNo || r.item || "도면보기"}
                          </a>
                        ) : (
                          r.drawingNo || r.item || "-"
                        )}
                      </td>

                      {/* 변경 전 */}
                      <td className="border-r border-black">
                        {r.before || "-"}
                      </td>

                      {/* 변경 후 */}
                      <td className="border-r border-black">
                        {r.after || "-"}
                      </td>

                      {/* 비고 */}
                      <td className="text-center">
                        {r.note || "-"}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5} className="text-center py-4 text-sm">
                    변경 항목 내역이 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <ApprovalActionDoc dns={dns} />
      <SignTableDoc dns={dns} />

      {/* 🔽 검토의견서 저장 버튼 */}
      <div className="print-avoid-break">
        <div className="flex justify-between mt-4 mb-2 ">
          <h2 className="text-body-bold mt-4">검토의견서</h2>

          <div className="flex gap-2 no-print">
            {/* 🔹 수정 버튼: 검토자 + 읽기모드 */}
            {isReviewer && !isEditingReview && (
              <button
                type="button"
                onClick={() => setIsEditingReview(true)}
                className="btn-edit"
              >
                수정
              </button>
            )}

            {/* 🔹 저장/취소 버튼: 검토자 + 편집모드 */}
            {isReviewer && isEditingReview && (
              <>
                <button
                  type="button"
                  onClick={handleSave}
                  className="btn-save"
                >
                  저장
                </button>
                <button
                  type="button"
                  onClick={() => setIsEditingReview(false)}
                  className="btn-cancel"
                >
                  취소
                </button>
              </>
            )}
          </div>
        </div>
        <ReviewOpinionDoc
          editing={isReviewer && isEditingReview}
          data={meta}
          form={form}
          handleChange={handleChange}
          editorRef={editorRef}
        />

      </div>

    </div>
  );
}
